<template>
  <div class="meter-replace">
    <el-dialog title="换表" z-index="990" :visible.sync="updateDialogVisible" :close-on-click-modal="false" width="1000px">
      <div style="max-height: 65vh;overflow-y: scroll;">
        <el-descriptions class="margin-top" title="" :column="2" size="mini" border>
          <el-descriptions-item label="仪表编号">
            {{form.number}}
          </el-descriptions-item>
          <el-descriptions-item label="倍率">
            <el-input size="mini" class="form-input" v-model="update_form.magnification" autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="所在房产">
            {{form.house_name}}
          </el-descriptions-item>
          <el-descriptions-item label="初始读数">
            <el-input size="mini" class="form-input" v-model="update_form.start_number" autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="仪表类型">
            {{getItem(meter_type_list,'id',form.meter_type).name}}
          </el-descriptions-item>
          <el-descriptions-item label="回程">
            <el-input size="mini" class="form-input" v-model="form.return_trip" autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="收费标准">
            {{getItem(house_charge_list,'id',form.charging_standard).name}}
          </el-descriptions-item>
          <el-descriptions-item label="安装日期">
            <el-date-picker v-model="update_form.install_time" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="仪表状态">
            {{getItem([{name:'在用',val:1},{name:'停用',val:2}],'val',form.status).name}}
          </el-descriptions-item>
          <el-descriptions-item label="位置">
            <el-input size="mini" class="form-input" v-model="update_form.position" autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="仪表性质">
            {{getItem(meter_nature_list,'val',form.meter_nature).name}}
          </el-descriptions-item>
          <el-descriptions-item label="备注">
            <el-input type="textarea" placeholder="请输入内容" v-model="update_form.remarks" maxlength="100" show-word-limit></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="附件">
            <el-row>
              <el-col :span="12">
                <el-link type="primary" @click="$refs.ViewFileListRef.UploadFile(data=>{update_form.files=data.id},update_form.files)">上传附件</el-link>
              </el-col>
              <el-col :span="12">
                <el-link type="primary" v-if="update_form.files" @click="$refs.ViewFileListRef.show(update_form.files)">查看下载</el-link>
              </el-col>
            </el-row>
          </el-descriptions-item>
        </el-descriptions>
        <el-divider></el-divider>
        <el-descriptions class="margin-top" title="" :column="2" size="mini" border>
          <el-descriptions-item label="上次读数">{{last_mater_note.read_number||0}}</el-descriptions-item>
          <el-descriptions-item label="上次抄表日期">{{dateFormat(last_mater_note.read_time,"YYYY-MM-DD")}}</el-descriptions-item>
          <el-descriptions-item label="最后读数">
            <el-input size="mini" class="form-input" v-model="update_form.end_number" @input="updateFormUseNumber" autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="	更换日期">
            <el-date-picker
              v-model="update_form.meter_update_time"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="最后用量">
            <el-input size="mini" class="form-input" v-model="update_form.end_use" autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="更换人">
            <el-input size="mini" class="form-input" style="width: 200px;" v-model="update_form.admin_name" readonly autocomplete="off"></el-input>
            <el-button @click="selectUser(update_form)">选择</el-button>
          </el-descriptions-item>
        </el-descriptions>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="updateDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateSubmitForm()">确 定</el-button>
      </div>
    </el-dialog>
    <select-personnel ref="selectPersonnel" />
    <ViewFileList ref="ViewFileListRef" />
  </div>
</template>

<script>
import MeterHttp from "../../../common/MeterHttp";
import SelectPersonnel from "../../../../Personnel/components/selectPersonnel";
import ViewFileList from "../../../../Common/ViewFileList";
import moment from "moment";

export default {
  name: "MeterReplace",
  inject:['mainObj'],
  components: {SelectPersonnel,ViewFileList},
  data() {
    return {
      updateDialogVisible: false,
      form: {},
      update_form: {},
      meter_type_list: [],
      house_charge_list: [],
      meter_nature_list:[{name:'分表',val:1},{name:'总表',val:2},{name:'分摊表',val:3},{name:'电力负荷表',val:4}],
      energy_list:[{name:"业主能耗",val:1},{name:"物业能耗",val:2},{name:"分摊能耗",val:3},],
      host_url: __HTTP__.defaults.baseURL,
      last_mater_note:{},
    };
  },
  // created() {
  //   this.getMeterTypeList();
  //   this.getHouseChargeList();
  //   this.getMeterNatureList();
  // },
  methods: {
    show(formData){
      this.updateDialogVisible = true;
      this.form = reObject(formData);
      this.update_form = reObject(formData);
      this.getLastMaterNote();
      this.getMeterTypeList();
      this.getHouseChargeList();
    },
    getLastMaterNote(){
      const that=this;
      MeterHttp.post("MeterNote/getLastMaterNote?user_type="+(that.$route.query.type||0),{
        meter_id:that.update_form.id,
        project_id:that.mainObj.project_id,
      },ret=>{
        if(ret.code){
          that.last_mater_note=ret.data||{};
        }
      });
    },
    updateSubmitForm() {
      var that = this;
      that.formLoading = true
      //原仪表
      let update_form = Object.assign({}, this.update_form)
      update_form.is_update=1;
      MeterHttp.post("Meter/save?user_type="+(that.$route.query.type||0),{
        ...update_form,
        last_read_number:that.last_mater_note.read_number,
        last_read_time:that.last_mater_note.read_time,
      }, res => {
        if (res.code) {
          that.updateDialogVisible = false
          that.getList()
          that.formLoading = false
        }
      });
    },
    selectUser(update_form){
      const that=this;
      that.$refs.selectPersonnel.show({user_ids:"",user_len:1},user_list=>{
        if(user_list.length){
          update_form.admin_name=user_list[0].username;
          update_form.admin_id=user_list[0].id;
        }
      })
    },
    updateFormUseNumber(){
      const that=this;
      let last_mater_note=that.last_mater_note||{};
      let read_number=(last_mater_note.read_number||0)*1;
      that.update_form.end_use=that.update_form.end_number-read_number
    },
    getMeterTypeList(){
      const that = this;
      let where={};
      MeterHttp.get("MeterType/getList",{
        project_id:that.mainObj.project_id,
        where:JSON.stringify(where),
        field:"id,name,expenditure_ids,expenditure_name",
        page: 1,
        page_size: 200
      },ret=>{
        if(ret.code){
          that.meter_type_list=ret.data.list;
        }
      });
    },
    getHouseChargeList(){
      const that = this;
      let where={};
      this.form.project_id&&(where.pindex_id=this.form.project_id);
      this.chargeItem_name_ids&&(where.chargeItem_name_ids=this.chargeItem_name_ids);
      ERP.getRequest({
        url:"admin/HouseCharge/getList",
        data:{
          project_id:that.mainObj.project_id,
          where:JSON.stringify(where),
          page: 1,
          page_size: 200
        }
      },ret=>{
        if(ret.code){
          that.house_charge_list=ret.data.list;
        }
      });
    },
    getItem(list,key,val){
      for(let i=0;i<list.length;i++){
        if(list[i][key]===val){
          return list[i];
        }
      }
      return {};
    },
    dateFormat(value,format="YYYY-MM-DD"){
      if(value){
        return moment(value*1000).format(format);
      }
      return "";
    }
  }
}
function reObject(item) {
  return JSON.parse(JSON.stringify(item));
}
</script>

<style lang="scss" scoped>
@import "../../../common";
.meter-replace{
  >>> .el-dialog{
    .el-dialog__body{
       padding: 10px;
     }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter/components/MeterReplace.vue